<body class="d-body">
  <div class="body create-course">
    <iq-central-front-end-header
      (routeChoosen)="goToChoosenRoute($event)"
    ></iq-central-front-end-header>
    <div class="container">
      <div class="row">
        <div class="col-lg-2 col-sm-12"></div>
        <div class="col-lg-8 col-sm-12">
          <ul class="nav nav-pills mb-3 justify-content-center my-5">
            <li class="nav-item" routerLink="./">
              <a class="nav-link">
                <span class="number">1</span> COURSE OVERVIEW</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link active">
                <span class="number">2</span> ADD LESSONS</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"><span class="number">3</span>CONTENT</a>
            </li>
          </ul>
        </div>
        <div class="col-lg-2 col-sm-12"></div>
      </div>
    </div>

    <section class="my-5 container">
      <div class="text-center my-4">
        <h3 class="font36 text-grey">Select Content Type</h3>
        <div class="my-5 d-flex justify-content-center">
          <div
            class="select-card click"
            [routerLink]="['/courses/add-video/', lessonId, courseCode]"
          >
            <img src="assets/icons/youtube-lg.png" alt="" />
            <p>Upload Video content</p>
          </div>
          <div
            class="select-card click"
            [routerLink]="['/courses/add-pdf/', lessonId, courseCode]"
          >
            <img src="assets/icons/book-lg.png" alt="" />
            <p>Upload PDF content</p>
          </div>
          <div
            class="select-card click"
            [routerLink]="['/courses/add-quiz/', lessonId, courseCode]"
          >
            <img src="assets/icons/checklist-lg.png" alt="" />
            <p>Upload Quiz content</p>
          </div>
        </div>
      </div>
    </section>
  </div>
  <div class="mt-auto hidden">
    <div class="footer-wrapper container">
      <hr />
      <iq-central-front-end-footer></iq-central-front-end-footer>
    </div>
  </div>
</body>
